import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "./style.scss";
import "../style.scss";
import { Link } from "react-router-dom";
import { getRouting } from "../../../../../utils/common";
import { getWeeklyPortfolioDetails } from "../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const WeeklyPortfolio = (props) => {
    const {
        getWeeklyPortfolioDetails,
        ourWeeklyPortfolioData,
        location: { pathname },
    } = props;

    const [ourPortfolioData, setourPortfolioData] = useState();
    const [metaData, setMetaData] = useState();

    useEffect(() => {
        getWeeklyPortfolioDetails();
    }, [])

    useEffect(() => {
        if (ourWeeklyPortfolioData && ourWeeklyPortfolioData.filesData) {
            setourPortfolioData(ourWeeklyPortfolioData.filesData)
        }

        if (ourWeeklyPortfolioData && ourWeeklyPortfolioData.meta && ourWeeklyPortfolioData.meta !== null) {
            setMetaData(ourWeeklyPortfolioData.meta)
        }

        else {
            setMetaData("")
        }
    }, [ourWeeklyPortfolioData])

    console.log('ourWeeklyPortfolioData', ourPortfolioData);

    return (
        <div className="wrapper">
            {
                metaData ? (
                    <Helmet>
                        <title>{metaData && metaData.title ? metaData.title : ""}</title>
                        <meta name="description"
                            content={
                                metaData && metaData.description ? metaData.description : ""
                            }
                        />
                        <meta name="keywords"
                            content={
                                metaData && metaData.keywords ? metaData.keywords : ""
                            }
                        />
                        <meta property="og:title"
                            content={
                                metaData && metaData.og_title ? metaData.og_title : ""
                            }
                        />
                        <meta property="og:description"
                            content={
                                metaData && metaData.og_description ? metaData.og_description : ""
                            }
                        />
                        <meta property="og:image"
                            content={
                                metaData && metaData.og_image ? metaData.og_image : ""
                            }
                        />
                        <meta property="og:url"
                            content={
                                metaData && metaData.og_url ? metaData.og_url : ""
                            }
                        />
                    </Helmet>
                ) : ("")
            }
            <section className="aboutHead">
                <div className="container">
                    <div className="d-flex">
                        <h1 className="me-auto">
                            <span>Weekly Debt & Portfolio </span>Details
                        </h1>

                        <nav aria-label="breadcrumb" className="align-self-center breadCrumbCust d-md-inlin">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item"><a href="/investor-services">Investor Services</a></li>
                                <li className="breadcrumb-item active breadcolor" aria-current="page">Weekly Debt & Portfolio Details</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>
            <section className="container pb-5">
                <div className="infocard my-5">
                    <div className="row justify-content-center">
                        {ourPortfolioData && ourPortfolioData.length > 0 && ourPortfolioData.map((item) => (
                            <div className="col-md-3">
                                <a href={item.url} target="_blank">
                                <div className="card animate">
                                    <div className="bg-grey">
                                        <div className="pdfimg">
                                            <img alt="excel" src="/images/New/InvestorService/excel.svg" /> 
                                        </div>
                                    </div>

                                    <div className="card-body">
                                        <h2 className="card-title">{item.title}</h2>
                                        View Details
                                    </div>
                                </div>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

const mapStateToProps = (state) => ({
    ourWeeklyPortfolioData: state.InvesterServices.ourWeeklyPortfolioData,
});

const mapDispatchToProps = (dispatch) => ({
    getWeeklyPortfolioDetails: bindActionCreators(getWeeklyPortfolioDetails, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WeeklyPortfolio);

